import axios, {isAxiosError} from 'axios';
import {saveAs} from 'file-saver';
import {getReturnUrl, logout} from './helpers';
import router from './plugins/router';

const apiEndpoints: Record<string, string> = {
  'keywordmanager.revenuedriver.com': 'https://keywordmanager.revenuedriver.com/api',
  'dev-keywordmanager.revenuedriver.com': 'https://dev-keywordmanager.revenuedriver.com/api',
  'localhost': '/api',
  '127.0.0.1': '/api',
};

const client = axios.create({
  baseURL: apiEndpoints[window.location.hostname],
});

export default {
  async execute(method: string, resource: string, data?: object | null, headers?: object | null, signal?: AbortSignal) {
    try {
      // inject the accessToken for each request
      const response = await client({
        method,
        url: resource,
        headers: {'x-jwt-token': localStorage.getItem('access-token'), ...headers},
        data,
        signal,
      });
      return response.data;
    } catch (e) {
      if (isAxiosError(e) && (e.response?.status === 401 || e.response?.status === 403) && router.currentRoute.path !== '/login') {
        logout();
        const returnUrl = getReturnUrl(router.currentRoute);
        await router.push({path: '/login', query: {returnUrl}});
      }
      throw e;
    }
  },
  getUser(email: string, password: string) {
    return this.execute('post', '/user', {email, password}).catch(err => {
      if (err.response) {
        return err.response.status;
      }
    });
  },
  async downloadKeywordsV2(params: URLSearchParams) {
    const response = await client.get('/campaigns-archive/download-keywords-v2', {
      params,
      headers: {'x-jwt-token': localStorage.getItem('access-token')},
      responseType: 'blob',
    });
    const re = /attachment; filename="(?<filename>[\w-]+.xlsx)"/;
    const contentDisposition = response.headers['content-disposition'];
    if (typeof contentDisposition === 'string') {
      const match = re.exec(contentDisposition);
      if (match && match.groups) {
        saveAs(response.data, match.groups.filename);
      }
    }
  },
};

export const httpClient = axios.create({
  baseURL: apiEndpoints[window.location.hostname],
  headers: {'x-jwt-token': localStorage.getItem('access-token')},
  timeout: 1000 * 30,
});
